

































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";

import UserDetail from "@/views/users/detail.vue";

import CardDetail from "@/views/card/detail.vue";

import AiHistory from "./ai-history.vue";

@Component({
  components: {
    UserDetail,
    CardDetail,
    AiHistory
  }
})
export default class extends Mixins(MyForm) {
  @Prop({ default: 0 }) isOld!: number;

  userId = 0;

  cardId = 0;

  accessToken: string = "";

  userDetailModalVisible = false;

  cardDetailModalVisible = false;

  aiHistoryModalVisible = false;

  items: any[] = [];

  cameras: any[] = [];

  camera_begin: string = "";
  camera_end: string = "";

  stadiumId: string = "";

  renderOriginPrice(str: string) {
    if (str) {
      if (str.indexOf("(*);") !== -1) {
        const arr = str.split(";");
        return `(${arr[0].replace("(*)", arr[1])})`;
      }
      return str;
    }
    return "";
  }

  showCardDetailModal(id: number) {
    this.cardId = id;
    this.cardDetailModalVisible = true;
  }

  hideCardDetailModal() {
    this.cardDetailModalVisible = false;
  }

  showUserDetailModal(id: number) {
    this.userId = id;
    this.userDetailModalVisible = true;
  }

  hideUserDetailModal() {
    this.userDetailModalVisible = false;
  }

  showAiHistoryModal() {
    this.aiHistoryModalVisible = true;
  }

  hideAiHistoryModal() {
    this.aiHistoryModalVisible = false;
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("bill/detail", {
      id: this.editId,
      is_old: this.isOld
    });

    if (res && res.Data) {
      this.formData = res.Data;

      this.stadiumId = res.Data.stadium_id;

      this.camera_begin = res.Data.camera_begin;
      this.camera_end = res.Data.camera_end;

      this.accessToken = res.Data.camera_token;
      if (_.has(res, ["Data", "list", "items"])) {
        this.items = _.get(res, ["Data", "list", "items"]);
      } else {
        this.items = _.get(res, ["Data", "list"]);
      }

      this.loadCameras();
    }
    this.spinLoading = false;
  }

  showPlayerModal(name: string, thumbnail: string, url: string, begin: string, end: string) {
    // url += "?begin=20211220130000&end=20211220140000";
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const d = window.dialog({
      title: `${name}的监控`,
      url: `/player.html?mode=rec&begin=${begin}&end=${end}&url=${url}&thumbnail=${thumbnail}&accessToken=${
        this.accessToken
      }`,
      zIndex: 2147483647
    });
    // console.log(d)
    d.show();
  }

  async loadCameras() {
    const res4 = await this.$store.dispatch("datav/stadiumCamera", {
      stadium_id: this.stadiumId
    });
    if (res4 && res4.Data) {
      this.cameras = res4.Data.lists;
      this.accessToken = res4.Data.access_token;
    }
  }
}
